/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "MqttService";
const log: any = LoggerModule.getInstance();

export class MqttService {
  private static instance: MqttService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): MqttService {
    if (!MqttService.instance) {
      MqttService.instance = new MqttService(props);
    }
    return MqttService.instance;
  }

  public async init(args: any) {
    const agent = getAgent();
    const response = await agent.init(args);
    console.log("mqtt response in index", response);
    return response;
  }
}
